// Animaciones Stackerz (ver assets/stackerz-fx.css). Con "reducir movimiento" no se activa nada.
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('fx');

  // ---------- Aparecer al bajar: solo lo que está debajo de la pantalla (lo visible al cargar no parpadea) ----------
  const SEL = '.section .heading, .product-card, .category-tile, .sz-new__viewport, .catalog-toolbar';
  const io = 'IntersectionObserver' in window && new IntersectionObserver((entries) => {
    for (const e of entries) if (e.isIntersecting) { e.target.classList.add('fx-in'); io.unobserve(e.target); }
  }, { rootMargin: '0px 0px -6% 0px' });
  const scan = () => {
    if (!io) return;
    let i = 0;
    for (const el of document.querySelectorAll(SEL)) {
      if (el.dataset.fx) continue;
      el.dataset.fx = '1';
      if (el.getBoundingClientRect().top < innerHeight) continue;
      el.classList.add('fx-reveal');
      el.style.setProperty('--fx-d', `${(i++ % 4) * 80}ms`); // las de una misma fila entran escalonadas
      io.observe(el);
    }
  };
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true }); // productos que llegan después (ver más, orden)

  // ---------- Al carrito: la foto vuela al ícono del carrito y el contador rebota ----------
  // Se recuerda la foto del producto al enviar el formulario; cuando el contador del carrito cambia, se anima.
  let flySrc = null;
  document.addEventListener('submit', (e) => {
    const form = e.target.closest?.('[data-quick-add], [data-product-detail] form');
    if (!form) return;
    const scope = form.closest('.product-card, [data-product-detail]');
    flySrc = { img: scope?.querySelector('.product-media img, .detail-media img'), at: Date.now() };
  }, true);
  const bump = () => document.querySelectorAll('.stackerz-cart-count').forEach((c) => { c.classList.remove('sz-bump'); void c.offsetWidth; c.classList.add('sz-bump'); });
  new MutationObserver(() => {
    const src = flySrc;
    const cart = document.querySelector('.stackerz-cart-link');
    flySrc = null;
    if (src && src.img && cart && Date.now() - src.at < 6000) {
      const a = src.img.getBoundingClientRect(), b = cart.getBoundingClientRect();
      if (a.width) {
        const size = Math.min(120, a.width);
        const g = Object.assign(document.createElement('img'), { src: src.img.currentSrc || src.img.src, className: 'sz-fly', alt: '' });
        Object.assign(g.style, { left: `${a.left + a.width / 2 - size / 2}px`, top: `${a.top + a.height / 2 - size / 2}px`, width: `${size}px`, height: `${size}px` });
        document.body.appendChild(g);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
          g.style.transform = `translate(${dx}px, ${dy}px) scale(.15)`; g.style.opacity = '.4';
        }));
        setTimeout(() => { g.remove(); bump(); }, 760);
        return;
      }
    }
    bump();
  }).observe(document.querySelector('.stackerz-cart-count') || document.createElement('i'), { childList: true, characterData: true, subtree: true });

  // ---------- Banners: profundidad con el mouse/celular y barra de tiempo en los puntos ----------
  for (const car of document.querySelectorAll('.sc-carousel')) {
    car.style.setProperty('--sc-int', `${Number(car.dataset.interval) || 7000}ms`);
    const pause = car.querySelector('[data-pause]');
    const syncPause = () => car.classList.toggle('sz-paused', pause?.getAttribute('aria-pressed') === 'true' || car.dataset.autoplay !== 'true');
    syncPause();
    if (pause) new MutationObserver(syncPause).observe(pause, { attributes: true, attributeFilter: ['aria-pressed'] });
    let pr = 0;
    const tilt = (x, y) => { cancelAnimationFrame(pr); pr = requestAnimationFrame(() => { car.style.setProperty('--px', x.toFixed(3)); car.style.setProperty('--py', y.toFixed(3)); }); };
    car.addEventListener('pointermove', (e) => { const r = car.getBoundingClientRect(); tilt((e.clientX - r.left) / r.width - 0.5, (e.clientY - r.top) / r.height - 0.5); }, { passive: true });
    car.addEventListener('pointerleave', () => tilt(0, 0));
    // En el celular: inclinarlo mueve el logo (Android lo da sin permiso; en iPhone queda quieto).
    addEventListener('deviceorientation', (e) => { if (e.gamma == null) return; tilt(Math.max(-0.5, Math.min(0.5, e.gamma / 60)), Math.max(-0.5, Math.min(0.5, (e.beta - 40) / 80))); }, { passive: true });
  }

  // ---------- Holo: inclinación 3D + brillo que sigue al mouse (solo con mouse; en el celular no) ----------
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  let cur = null, raf = 0;
  const reset = (m) => { m.classList.remove('fx-tilting'); m.style.removeProperty('--rx'); m.style.removeProperty('--ry'); };
  document.addEventListener('pointermove', (e) => {
    const m = e.target.closest?.('.product-card .product-media');
    if (cur && cur !== m) { reset(cur); cur = null; }
    if (!m) return;
    if (!m.querySelector('.sz-holo')) m.insertAdjacentHTML('beforeend', '<span class="sz-holo" aria-hidden="true"></span>');
    cur = m;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const r = m.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      m.classList.add('fx-tilting');
      m.style.setProperty('--ry', `${((x - 0.5) * 14).toFixed(2)}deg`);
      m.style.setProperty('--rx', `${((0.5 - y) * 11).toFixed(2)}deg`);
      m.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`);
      m.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
      m.style.setProperty('--hx', `${(x * 100).toFixed(1)}%`);
      m.style.setProperty('--hy', `${(y * 100).toFixed(1)}%`);
    });
  }, { passive: true });
  document.addEventListener('pointerleave', () => { if (cur) { reset(cur); cur = null; } });
})();
